import { useQuery } from 'react-query';
import { toast } from 'react-toastify';

import { fetchCountries } from '../api';

const useCountries = () => {
  return useQuery('countries', fetchCountries, {
    onError: (error) => {
      toast.error((error.response && error.response.data.message) || 'Network Error');
    }
  });
};

export { useCountries };
